import { ROUTES_NAMES, TRUE_TO_STRING } from '@/constants';
import { getCurrentUser, isAuthenticated, isExternalProvider, redirectToCallbackURL, setTokens } from '@/service/cognitoService';
import store from '@/store';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export const beforeEnterLoginFederatedRoute = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> => {
  const clientId = sessionStorage.getItem('clientID');
  const redirectURI = sessionStorage.getItem('redirectURI');
  const userIsAuthenticated = await isAuthenticated();

  if (!clientId || !redirectURI || !userIsAuthenticated) {
    return next({ name: ROUTES_NAMES.error });
  }

  const { attributes, username } = await getCurrentUser();
  const isFirstLogin = attributes['custom:first_login'] === TRUE_TO_STRING;

  store.dispatch('setClientID', clientId);
  store.dispatch('setRedirectURI', redirectURI);
  await setTokens();

  if (!isExternalProvider(username) ||
  (isExternalProvider(username) && !isFirstLogin)) {
    next(false);
    return redirectToCallbackURL();
  }

  next();
};
